import {Observable} from 'rxjs';

export interface PomocLista {
  // uuid?: string;
  nazwa?: string;
  link?: string;
  tagi?: string;
  trescProsta?: string;
  sciezkaUrl?: string;
  // czyWlasciciel?: boolean;
  numerWTabeli?:number;
}

export interface PomocSzczegoly {
  // uuid?: string;
  link?: string;
  nazwa?: string;
  tresc?: string;
}

/**
 * Interfejs definiuje adapter pomocy
 */
export interface PomocAdapter {

  /**
   * Funkcja pozwala wyszukiwać liste pomocy
   * @param fraza
   */
  getListaPomocy(fraza: string): Observable<PomocLista[]>;

  /**
   * Funkcja pobiera szczegóły pomocy
   * @param sciezka
   */
  getSzczegolyPomocy(sciezka: string): Observable<PomocSzczegoly>;
}


/**
 * Klasa abstrakcyjna definiuje adapter pomocy
 */
export abstract class PomocModulMapowyAdapter implements PomocAdapter{

  /**
   * Funkcja pozwala wyszukiwać liste pomocy
   * @param fraza
   */
  abstract getListaPomocy(fraza: string): Observable<PomocLista[]>;

  /**
   * Funkcja pobiera szczegóły pomocy
   * @param sciezka
   */
  abstract getSzczegolyPomocy(sciezka: string): Observable<PomocSzczegoly>;
}

/**
 * Bazowa implementacja adaptera pomocy
 */
export class DomyslnaPomocModulMapowyAdapter extends PomocModulMapowyAdapter{

  /**
   * Funkcja pozwala wyszukiwać liste pomocy
   * @param fraza
   */
  getListaPomocy(fraza: string): Observable<PomocLista[]> {
    return new Observable();
  }

  /**
   * Funkcja pobiera szczegóły pomocy
   * @param sciezka
   */
  getSzczegolyPomocy(sciezka: string): Observable<PomocSzczegoly> {
    return new Observable();
  }

}
